// extracted by mini-css-extract-plugin
export default {"footer-resources-links":"gtoSu","docs-link":"r8yFp","figma-link":"Ukq69","github-link":"lax2M","youtube-link":"oG1zj","tiktok-link":"cTeV1","telegram-link":"ptMQU"};